import { render } from "./viewComponent.vue?vue&type=template&id=0741d060&scoped=true"
import script from "./viewComponent.vue?vue&type=script&lang=js"
export * from "./viewComponent.vue?vue&type=script&lang=js"

import "./viewComponent.vue?vue&type=style&index=0&id=0741d060&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0741d060"]])

export default __exports__